import React from "react";
import Head from "../components/Head";
import Foot from "../components/Foot";

function NotFound() {
  return (
    <>
      <Head />
      <div style={{ paddingTop: 240 }} className="container">
        <div className="text-center">
          <img
            src="/assets/img/bg/404.png"
            alt="404 Error"
            style={{ maxWidth: 420, width: "100%", margin: "0 auto 40px", display: "block" }}
          />
          <h2 className="ak-section-title" style={{ marginBottom: 20 }}>
            Even our smartest students couldn't find this page! 🤓
          </h2>
          <p className="text-16" style={{ maxWidth: 560, margin: "0 auto 8px" }}>
            It may have graduated, transferred, or simply doesn't exist anymore.
          </p>
          <p className="text-16" style={{ maxWidth: 560, margin: "0 auto 32px" }}>
            Let's get you back to something useful.
          </p>
          <a href="/" className="common-btn">
            <span style={{ color: "white" }}>Back to Homepage</span>
          </a>
        </div>
      </div>
      <div className="ak-height-125 ak-height-lg-80" />
      <Foot />
    </>
  );
}

export default NotFound;
